import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../App";
import { Button } from "../../components/ui/button";
import BRAND from "../../brand";
import { Play } from "lucide-react";

export function FooterCTA() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCTA = () => {
    navigate(user ? "/dashboard" : "/login");
  };

  return (
    <>
      {/* FINAL CTA SECTION */}
      <section className="px-4 py-20 sm:py-28 sm:px-6 lg:px-8 bg-slate-50/50" data-testid="cta-section">
        <div className="flex flex-col items-center max-w-3xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#0B1F3B] mb-4 sm:mb-6 leading-[1.15]">
            Ready to Transform<br className="hidden sm:inline" /> Your Sales Team?
          </h2>
          <p className="max-w-xl mx-auto mb-8 text-base leading-relaxed sm:text-lg text-slate-500 sm:mb-10">
            Stop losing deals to unprepared conversations. Start building field-ready advisors today.
          </p>
          <div className="flex flex-col items-center w-full gap-3 sm:w-auto">
            <Button 
              onClick={handleCTA} 
              className="w-full sm:w-auto bg-[#0B1F3B] hover:bg-[#0B1F3B]/90 h-12 sm:h-14 px-10 text-base font-semibold text-white rounded-full transition-all shadow-sm hover:shadow-md btn-premium" 
              data-testid="final-cta-btn"
            >
              <Play className="w-5 h-5 mr-2 fill-current" /> Start Practice
            </Button>
            <p className="text-xs font-medium text-slate-400">No credit card required</p>
          </div>
        </div>
      </section>

      {/* FOOTER SECTION */}
      <footer className="bg-white border-t border-slate-200/80" data-testid="landing-footer">
        <div className="px-4 py-10 mx-auto max-w-7xl sm:px-6 lg:px-8 sm:py-12">
          <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left">
            
            {/* Left: Brand Identity */}
            <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:text-left">
              <img 
                src={BRAND.logoUrl} 
                alt="Logo" 
                className="object-contain w-auto h-7 sm:h-8" 
                onError={(e) => { e.currentTarget.style.display = 'none'; }} 
              />
              {/* <div className="flex flex-col">
                <p className="text-sm font-bold text-[#0B1F3B] tracking-wide">{BRAND.productName}</p>
                <p className="text-xs text-slate-400 mt-0.5">{BRAND.positioning.description}</p>
              </div> */}
            </div>
            
            {/* Center: Quick Links not requore abhi k lia */}
            {/* <div className="flex items-center gap-8 my-2 md:my-0">
              <Link to="/login" className="text-sm font-medium text-slate-500 hover:text-[#0B1F3B] transition-colors">
                Log In
              </Link>
              <Link to="/register" className="text-sm font-medium text-slate-500 hover:text-[#0B1F3B] transition-colors">
                Get Started
              </Link>
            </div> */}
            
            {/* Right: Attributions */}
            <div className="flex flex-col justify-center md:items-end">
              <p className="text-xs font-medium text-slate-400">{BRAND.poweredBy}</p>
              <p className="text-[11px] text-slate-300 mt-0.5">{BRAND.companyAttribution}</p>
            </div>

          </div>
        </div>
      </footer>
    </>
  );
}